import { Request } from '@konv/http';
import { UserStorage } from '../shared/tools/UserStorage';

export class OrdaticAPI {
	static async request({ endpoint = '/', method = 'GET', headers = {}, query = {}, data = {} }) {
		return await Request.request({
			endpoint: endpoint,
			method: method,
			headers: headers,
			service: 'ordatic',
			ignoreVersion: true,
			params: query,
			data: data
		});
	}

	static async requestAuthenticated({ endpoint = '/', method = 'GET', query, data }) {
		return await OrdaticAPI.request({
			endpoint,
			headers: { 'Authorization': 'Bearer ' + UserStorage.getAccessToken() },
			method,
			query,
			data,
		});
	}

	static async getStores(environmentId) {
		return OrdaticAPI.requestAuthenticated({
			endpoint: `/${environmentId}/stores`,
			method: 'GET',
		});
	}

	static async syncStore(environmentId) {
		return OrdaticAPI.requestAuthenticated({
			endpoint: `/${environmentId}/stores/sync`,
			method: 'POST',
		});
	}
}